<script setup lang="ts">
/**
 * CaPriceCard — kartu harga. Harga memakai skala `ca-price`
 * (800-weight, tabular-nums) supaya angka rupiah terbaca tegas dan tidak bergoyang.
 * Varian `sorot` memberi border 2px + badge — hanya BOLEH dipakai pada satu SKU per halaman.
 */
defineProps<{
  nama: string
  ringkas: string
  harga: number
  satuan?: string
  fitur: string[]
  ctaLabel: string
  ctaTo: string
  sorot?: boolean
  badge?: string
}>()

const rupiah = (n: number) => 'Rp' + n.toLocaleString('id-ID')
</script>

<template>
  <CaCard :tone="sorot ? 'brand' : 'plain'" class="flex flex-col h-full relative">
    <CaBadge v-if="badge" tone="brand" class="absolute -top-3 left-5">{{ badge }}</CaBadge>

    <p class="ca-h3">{{ nama }}</p>
    <p class="mt-1 text-sm text-muted leading-relaxed">{{ ringkas }}</p>

    <p class="ca-price mt-5 text-ink">
      {{ rupiah(harga) }}<span
        v-if="satuan"
        class="ml-1.5 text-sm font-medium text-muted tracking-normal"
      >{{ satuan }}</span>
    </p>

    <ul class="mt-5 flex flex-col gap-2.5 flex-1">
      <li v-for="f in fitur" :key="f" class="flex gap-2.5 text-[0.9375rem] leading-relaxed">
        <UIcon name="i-lucide-check" class="size-5 shrink-0 text-ok mt-0.5" />
        <span>{{ f }}</span>
      </li>
    </ul>

    <CaButton
      class="mt-6"
      :variant="sorot ? 'primary' : 'secondary'"
      size="lg"
      block
      :to="ctaTo"
    >
      {{ ctaLabel }}
    </CaButton>
  </CaCard>
</template>
